/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const get_ticket = /* GraphQL */ `
  query Get_ticket($input: ticketInputs) {
    get_ticket(input: $input)
  }
`;
export const list_tickets = /* GraphQL */ `
  query List_tickets($input: ticketInputs) {
    list_tickets(input: $input)
  }
`;
